

const Color = {
    theme: "#00BAFF",
    blue: "#0076FF",
    red: "#FF3B30",
    green: "#7ED321",
    white: "#FFFFFF",
    black: "#000000",
    orange: "#F5A623",
    purple: "#9900cc",
    yellow: "#ffff00",
    extraLightGray: "#D8D8D8",
    lightGray: "#8E8E93",
    darkGray: "#4A4A4A",
    systemGray: "#EFEFF4",
    lineColor: "#EFEFF4", //"#d9d9d9",
    optionColor: "#38f9d7",
    time: '#7FABDA',
    timeAlpha: '#7FABDA60',
    clear: 'rgba(255, 255, 255, 0)',
	avatar_gray: '#C7C6CB',
    home_page_header: '#F6F6F6',
    low_block: '#22C6FB',
    normal_low_block: '#2BFCDE',
    normal_block: '#34A921',
    normal_high_block: '#F8CB33',
    mild_hyper_block: '#F67B2B',
    moderate_hyper_block: '#F84C24',
    severe_hyper_block: '#E10B1B',
    bottom_bar: '#FDFDFD',
    chat_message_item_others: '#F1F0F0',
    message_appointment: '#00BAFF',
    message_labResult: '#89F7FE',
    message_medication: '#FDA085',
    message_education: '#F0574C',
    message_other: '#7FABDA',
    message_all: '#8E8E93',
    message_unread: '#8E8E93',

    share_border: '#FAFAFA',
    panel_handler: '#DADCDF',

    favorite: '#FF4081',

    switch_off: '#E5E5EA',

    chat_bg: '#f2f2f2'
};


export {
    Color
}

